import { Box, CircularProgress, Typography, useTheme } from '@mui/material';
import { WAF_YELLOW } from '../theme';
import wafLogoUrl from '../assets/waf-logo.png';

// Dark-background variant of the logo, if present (mirrors Layout's logic so
// the loading screen matches the header in either colour mode).
const darkLogoModules = import.meta.glob<{ default: string }>('../assets/waf-logo-dark.png', {
  eager: true,
});
const wafLogoDarkUrl: string | null = Object.values(darkLogoModules)[0]?.default ?? null;

interface LoadingScreenProps {
  /** Optional caption under the spinner (e.g. "Loading…"). Omit for just the mark. */
  label?: string;
  /** Vertical space to fill. Defaults to most of the viewport so it centres nicely. */
  minHeight?: number | string;
}

/**
 * Centres the WAF logo (header size) above a yellow Material spinner — the
 * standard "content is loading" state across every screen.
 */
export function LoadingScreen({ label, minHeight = '60vh' }: LoadingScreenProps) {
  const theme = useTheme();
  const logoSrc = theme.palette.mode === 'dark' && wafLogoDarkUrl ? wafLogoDarkUrl : wafLogoUrl;

  return (
    <Box
      sx={{
        minHeight,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
      }}
    >
      <Box
        component="img"
        src={logoSrc}
        alt=""
        sx={{ height: { xs: 28, sm: 56 }, width: 'auto', display: 'block' }}
      />
      <CircularProgress sx={{ color: WAF_YELLOW }} />
      {label && (
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
      )}
    </Box>
  );
}
